export class Agent {

    id: number;
    nom: string;
    prenom: string;
    sexe: string;
    login: string;
    password: string;
    confirmer: string;
    email: string;
    shouldChangePassword: boolean;
    profil: any;
    etat: boolean;
    partenaire: any;
    role: string;
    nomPdg : string;

    constructor() { }
}
